import { ICityInfo } from '../../interfaces/venue/city-info.interface';

export class CityInfo implements ICityInfo {

  readonly zipCode: string;
  readonly cities: string[];
  readonly county: string;

  constructor(iCityInfo: ICityInfo) {
    this.zipCode = iCityInfo.zipCode;
    this.cities = Array.isArray(iCityInfo.cities) ? iCityInfo.cities : [iCityInfo.cities];
    this.county = iCityInfo.county;
  }

}
